// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';

export default class InfoBookingForDate extends ApiObject {

  /**
   * The date as ms.
   * @type {number}
   */
  date: number = 0;


  /**
   * Hashmap with
   * - enum Period
   * - number of clients
   */
  occupancy: Object = {};

  haveNoBooking(): boolean {
    let res = 0;
    _.forIn(this.occupancy, (value) => {
      res += value;
    });

    return res === 0;
  }

}
